module.exports = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL,
    REACT_APP_VERSION: process.env.REACT_APP_VERSION,
    SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
    ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
    FLAGSMITH_API_KEY: process.env.REACT_APP_FLAGSMITH_API_KEY,
}
